import React, { useEffect, useRef } from "react";
import "../App.css";
import { useTranslation } from "react-i18next";
import videoFile from "./aidan-li-pommel-horse-routine-2025-world-championships.mp4";
const Thumbnail =
  "/images/aidan-li-pommel-horse-routine-2025-world-championships-thumbnail.png";

export default function AidanRoutine() {
  const videoRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    const el = videoRef.current;
    const onFull = () => {
      el.style.objectFit = document.fullscreenElement ? "contain" : "cover";
    };
    document.addEventListener("fullscreenchange", onFull);
    return () => document.removeEventListener("fullscreenchange", onFull);
  }, []);

  return (
    <div className="ow-video-wrap">
      <div className="ow-video-frame">
        <video
          ref={videoRef}
          controls
          poster={Thumbnail}
          aria-label="Aidan Li artistic gymnastics pommel horse routine at the 2025 World Championships"
        >
          <source src={videoFile} type="video/mp4" />
        </video>
      </div>
      <p className="ow-video-caption">{t("world-routine")}</p>
    </div>
  );
}
